<template>
  <div>
    <async-button
      v-if="!memberLocked && memberDetails.member.generateIdCard"
      type="button"
      :disabled="submitEnabled ? null : 'disabled'"
      class="_mls _mt0 white --sm"
      :executing="isSubmitting"
      @clicked="
        handleFileDownload({
          reportId: memberDetails.member.memberCk,
          type: 'CARD',
          fileName: 'IdCard.pdf',
          dateOfService: memberDetails.member.benefitServiceDate,
          groupCk: memberDetails.member.groupCk,
          subGroupCk: memberDetails.member.subgroupCk || memberDetails.member.subGroupCk
        })
      "
    >
      <template #buttonContent>
        <span>PRINT ID CARD</span>
      </template>
    </async-button>
  </div>
</template>

<script>
  import memberManagement from '../../../mixins/memberManagement'
  import AsyncButton from '@molecules/AsyncButton'
  import { useReporting } from '@composables/useReporting'

  export default {
    components: {
      AsyncButton
    },
    mixins: [memberManagement],
    props: {
      submitEnabled: {
        type: Boolean,
        default: true
      },
      isSubmitting: {
        type: Boolean,
        default: false
      }
    },
    setup() {
      const { handleFileDownload } = useReporting()
      return {
        handleFileDownload
      }
    }
  }
</script>
